/* BLRB Custom JS — LyteBites v8.3 */
(function() {
  'use strict';

  /* --- Scroll Reveal --- */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.blrb-reveal, .blrb-reveal-scale').forEach(el => revealObserver.observe(el));

  /* --- Counter Animation --- */
  function animateCounter(el) {
    const target = parseInt(el.dataset.count, 10);
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 1800;
    const start = performance.now();
    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - t, 3);
      el.textContent = prefix + Math.round(ease * target) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        animateCounter(e.target);
        counterObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('[data-count]').forEach(el => counterObserver.observe(el));

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.blrb-faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.blrb-faq-item');
      const answer = item.querySelector('.blrb-faq-answer');
      const isOpen = item.classList.contains('active');

      document.querySelectorAll('.blrb-faq-item.active').forEach(other => {
        if (other !== item) {
          other.classList.remove('active');
          other.querySelector('.blrb-faq-answer').style.maxHeight = '0';
        }
      });

      if (isOpen) {
        item.classList.remove('active');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* --- Video Play/Pause --- */
  document.querySelectorAll('.blrb-video-card').forEach(card => {
    const video = card.querySelector('video');
    if (!video) return;
    card.addEventListener('click', () => {
      if (video.paused) {
        document.querySelectorAll('.blrb-video-card.playing').forEach(other => {
          if (other !== card) {
            other.classList.remove('playing');
            const v = other.querySelector('video');
            if (v) { v.pause(); v.muted = true; }
          }
        });
        video.muted = false;
        video.play();
        card.classList.add('playing');
      } else {
        video.pause();
        video.muted = true;
        card.classList.remove('playing');
      }
    });
  });

  /* --- Marquee Clone for Seamless Loop --- */
  document.querySelectorAll('.blrb-marquee-track').forEach(track => {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });

  /* --- Floating CTA — show after scrolling past hero --- */
  var floatingCta = document.getElementById('blrb-floating-cta');
  if (floatingCta) {
    var hero = document.getElementById('blrb-hero');
    var threshold = hero ? hero.offsetTop + hero.offsetHeight : 600;
    var ctaVisible = false;
    window.addEventListener('scroll', function() {
      var show = window.scrollY > threshold;
      if (show !== ctaVisible) {
        ctaVisible = show;
        if (show) floatingCta.classList.add('visible');
        else floatingCta.classList.remove('visible');
      }
    }, { passive: true });
  }

  /* --- Science section scroll scale --- */
  var scienceViz = document.querySelector('.blrb-science-visual');
  if (scienceViz && window.innerWidth > 768) {
    var scienceObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var ratio = Math.min(e.intersectionRatio, 1);
          var scale = 0.85 + (ratio * 0.15);
          scienceViz.style.transform = 'scale(' + scale + ')';
          scienceViz.style.opacity = 0.5 + (ratio * 0.5);
        }
      });
    }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
    scienceObserver.observe(scienceViz);
  }

  /* --- Drawer Anchor Links — close drawer + smooth scroll --- */
  document.querySelectorAll('[data-blrb-anchor]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = link.getAttribute('href');
      var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#')) : null;
      if (!hash) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      /* Close the Shrine drawer */
      var drawerDetails = document.getElementById('Details-menu-drawer-container');
      if (drawerDetails) drawerDetails.removeAttribute('open');
      /* Smooth scroll after drawer closes */
      setTimeout(function() {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    });
  });

  /* --- Parallax Engine (desktop only) --- */
  if (window.innerWidth > 768) {
    var ticking = false;
    var heroGlow = document.querySelector('.blrb-hero-glow');
    var showcaseGlow = document.querySelector('.blrb-showcase-glow');

    function updateParallax() {
      var scrollY = window.scrollY;
      if (heroGlow) {
        heroGlow.style.transform = 'translateY(' + (scrollY * 0.12) + 'px)';
      }
      if (showcaseGlow) {
        var rect = showcaseGlow.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          showcaseGlow.style.transform = 'translateY(' + ((rect.top - window.innerHeight / 2) * 0.06) + 'px)';
        }
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

})();
